/**
 * @file: 存储快照
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../../../stageStatus';
import Config from '../../../config';
import { addStackIn } from '../add';
import { removeStackIn } from '../remove';
import { numberKeyStackIn } from '../numberKey';
import { selectUpdateStackIn } from '../selectUpdate';
import { updateByApiStackIn } from '../updateByApi';
import { layerAlignStackIn } from '../layerAlign';
import { shortMoveStackIn } from '../shortMove';
import { shelfDragMoveStackIn } from '../shelfDragMove';
import { layerDragMoveStackIn } from '../layerDragMove';
import { goodsDragMoveStackIn } from '../goodsDragMove';
import { textareaDragMoveStackIn } from '../textareaDragMove';
import { bafflePlateDragMoveStackIn } from '../bafflePlateDragMove';
import { addSubStackIn } from '../addSub';
import { getStepCount } from './stepCount';
import { historyShift } from './shift';

async function stackIn(params: StackInParams): Promise<void> {
    // 卧柜暂不支持
    if (StageStatus.isTopFace()) {
        return;
    }
    let historyMaxStepCount: number = Config.get({
        moduleName: 'base',
        key: 'historyMaxStepCount'
    });

    switch(params.type) {
        case 'add':
            await addStackIn(params);
            break;

        case 'remove':
            await removeStackIn(params);
            break;

        case 'quickSurface':
            await numberKeyStackIn(params);
            break;

        case 'selectUpdate':
            await selectUpdateStackIn(params);
            break;

        case 'updateByApi':
            await updateByApiStackIn(params);
            break;

        case 'layerAlign':
            await layerAlignStackIn(params);
            break;

        case 'shortMove':
            await shortMoveStackIn(params);
            break;

        case 'shelfDragMove':
            await shelfDragMoveStackIn(params);
            break;

        case 'layerDragMove':
            await layerDragMoveStackIn(params);
            break;

        case 'goodsDragMove':
            await goodsDragMoveStackIn(params);
            break;

        case 'textareaDragMove':
            await textareaDragMoveStackIn(params);
            break;

        case 'bafflePlateDragMove':
            await bafflePlateDragMoveStackIn(params);
            break;

        case 'addSub':
            await addSubStackIn(params);
            break;

        default:
            break;
    }

    let stepCount: number = await getStepCount();

    if (stepCount > historyMaxStepCount) {
        historyShift();
    }

    return;
}

export {
    stackIn
};
